import { FilterDateChip } from "./FilterDateChip";
import { FilterStatusChip } from "./FilterStatusChip";

export const FilterSection: React.FC = () => {
  return (
    <section style={{ display: "flex", flex: 1, alignItems: "center", overflow: "auto" }}>
      <FilterStatusChip />
      <FilterDateChip />
    </section>
  );
};
